import React from "react";

// The premium Approved Creative Blueprint, Version 1. Client-facing.
export function ApprovedBlueprint({ bp, note }) {
  if (!bp) return null;
  const budget = bp.estimated_budget || {};
  const timeline = bp.estimated_timeline || {};
  const approach = bp.production_approach || {};

  return (
    <div className="max-w-[820px] mx-auto text-center animate-[fadeUp_400ms_ease-out_both]" data-testid="approved-blueprint">
      <div className="eyebrow eyebrow-denim">Approved Creative Blueprint · Version 1</div>
      <h2 className="mt-6 font-display font-extrabold text-ink leading-[1.02] tracking-[-0.035em] text-[32px] sm:text-[44px] md:text-[56px]">
        {bp.title}
      </h2>
      {bp.tagline && (
        <p className="mt-5 font-serif-italic text-muted-ink text-[18px] md:text-[21px] leading-[1.5]">
          &ldquo;{bp.tagline}&rdquo;
        </p>
      )}

      {note && (
        <div className="mt-12 max-w-[600px] mx-auto border-l-2 border-denim-bnm pl-6 text-left" data-testid="producer-personal-note">
          <div className="eyebrow eyebrow-muted mb-3">A note from your Producer</div>
          <p className="text-ink text-[16px] md:text-[17px] leading-[1.75] italic">{note}</p>
        </div>
      )}

      {bp.summary && (
        <div className="mt-14 max-w-[640px] mx-auto">
          <div className="eyebrow eyebrow-denim">The Vision</div>
          <p className="text-ink text-[16.5px] md:text-[18px] mt-5 leading-[1.8]">{bp.summary}</p>
        </div>
      )}

      {bp.creative_direction && (
        <div className="mt-14 max-w-[640px] mx-auto">
          <div className="eyebrow eyebrow-denim">Creative Direction</div>
          <p className="text-ink text-[16px] md:text-[17px] mt-5 leading-[1.8]">{bp.creative_direction}</p>
        </div>
      )}

      {Array.isArray(bp.deliverables) && bp.deliverables.length > 0 && (
        <div className="mt-14 max-w-[560px] mx-auto">
          <div className="eyebrow eyebrow-denim">Deliverables</div>
          <div className="mt-6 divide-y divide-[#eaeaea] border-t border-b border-[#eaeaea] text-left">
            {bp.deliverables.map((d, i) => (
              <div key={`${i}-${d}`} className="py-4 text-ink text-[16px]">{d}</div>
            ))}
          </div>
        </div>
      )}

      {budget.range && (
        <div className="mt-14" data-testid="blueprint-budget">
          <div className="eyebrow eyebrow-denim">Estimated Budget</div>
          <div className="mt-4 font-display font-extrabold text-ink text-[32px] md:text-[44px] leading-[1.1] tracking-[-0.02em]">
            {budget.range}
          </div>
          {budget.note && (
            <p className="text-muted-ink text-[15px] md:text-[16.5px] mt-5 leading-[1.75] max-w-[560px] mx-auto">{budget.note}</p>
          )}
        </div>
      )}

      {Array.isArray(timeline.phases) && timeline.phases.length > 0 && (
        <div className="mt-14 max-w-[620px] mx-auto" data-testid="blueprint-timeline">
          <div className="eyebrow eyebrow-denim">Estimated Timeline</div>
          <div className="mt-7 divide-y divide-[#eaeaea] border-t border-b border-[#eaeaea] text-left">
            {timeline.phases.map((p, i) => (
              <div key={`${i}-${p?.name}`} className="py-4 flex items-center justify-between gap-6">
                <div className="text-ink text-[16px]">{p?.name}</div>
                <div className="text-muted-ink text-[15px]">{p?.duration}</div>
              </div>
            ))}
          </div>
          {timeline.total && (
            <div className="mt-6 text-center">
              <div className="eyebrow eyebrow-muted">Total</div>
              <div className="mt-2 font-display font-extrabold text-ink text-[24px] md:text-[30px]">{timeline.total}</div>
            </div>
          )}
        </div>
      )}

      {approach.approach && (
        <div className="mt-14">
          <div className="eyebrow eyebrow-denim">Production Approach</div>
          <div className="mt-4 font-display font-extrabold text-ink text-[26px] md:text-[32px] tracking-[-0.02em]">
            {approach.approach}
          </div>
          {approach.explanation && (
            <p className="text-muted-ink text-[15.5px] md:text-[16.5px] mt-4 leading-[1.75] max-w-[560px] mx-auto">
              {approach.explanation}
            </p>
          )}
        </div>
      )}

      {Array.isArray(bp.next_steps) && bp.next_steps.length > 0 && (
        <div className="mt-14 max-w-[560px] mx-auto">
          <div className="eyebrow eyebrow-denim">Next Steps</div>
          <div className="mt-6 space-y-3 text-left">
            {bp.next_steps.map((s, i) => (
              <div key={`${i}-${s}`} className="flex gap-4 items-baseline">
                <span className="text-denim-bnm font-display font-bold text-[14px] shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <p className="text-ink text-[16px] leading-[1.7]">{s}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ApprovedBlueprint;
